const observe = function (element, event, handler) {
    if (element) {
        // JIRA_3079 - If element is present in the page then continue binding.
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent(`on${event}`, handler);
        } else {
            element[`on${event}`] = handler;
        }
    }
};
export default observe;
